import { GetScreenSaver, ScreenSaverUpload, SaveScreenSaver, GetScreenSaverInfo, ScreenBind } from '@/api/screen'
export default {
  state: {

  },
  actions: {
    GetScreenSaver ({ commit }, payload) {
      return new Promise(resolve => {
        GetScreenSaver(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    ScreenSaverUpload ({ commit }, payload) {
      return new Promise(resolve => {
        ScreenSaverUpload(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveScreenSaver ({ commit }, payload) {
      return new Promise(resolve => {
        SaveScreenSaver(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetScreenSaverInfo ({ commit }, payload) {
      return new Promise(resolve => {
        GetScreenSaverInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    ScreenBind ({ commit }, payload) {
      return new Promise(resolve => {
        ScreenBind(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {

  },
  mutations: {

  }
}
